/* eslint-disable @typescript-eslint/no-explicit-any */
import * as actionTypes from './actionTypes';

function reducer(state:{ readSalesOrderNotifications: [], salesOrder: [] }, action:{ payload: any, type: string }) {
  switch (action.type) {
    case actionTypes.SET_SALES_ORDER:
      return {
        ...state,
        salesOrder:  action.payload,
      };

    case actionTypes.APPEND_SALES_ORDER:
      return {
        ...state,
        salesOrder:  [...state.salesOrder, ...action.payload],
      };

    case actionTypes.SET_NO_MORE_SALES_ORDER:
      return {
        ...state,
        noMoreSalesOrder:  action.payload,
      };

    case actionTypes.SET_SALES_ORDER_FILTERS:
      return {
        ...state,
        salesOrderFilters: action.payload,
      };

    case actionTypes.SET_SALES_ORDER_NOTIFICATIONS:
      return {
        ...state,
        salesOrderNotifications: action.payload,
      };
  
    case actionTypes.SET_SALES_ORDER_STATE:
      return {
        ...state,
        salesState: action.payload,
      };

    case actionTypes.SET_NOTIFICATION_AS_READ:
      return {
        ...state,
        readSalesOrderNotifications: [...state.readSalesOrderNotifications, action.payload],
      };

    case actionTypes.SET_READ_SALES_ORDER_NOTIFICATIONS:
      return {
        ...state,
        readSalesOrderNotifications: action.payload,
      };
      
    default:
      return state;
  }
}

export default reducer;
